import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const Terms = () => {
    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, setVideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };





    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };



    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {



        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>

                {/* ---------- BENGALURU NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    Terms & Conditions
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>

                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-lg-8 primary_bg4">

                                <div className="trending-posts-4__wrapper mb-24">



                                    <div>


                                        <p className="mb-24">
                                            Welcome to Karnataka Police TV Magazine. By accessing and using this
                                            website, you agree to comply with and be bound by the following Terms &amp;
                                            Conditions. If you do not agree with any part of these terms, please refrain
                                            from using our website.
                                        </p>
                                        <h2>1. Acceptance of Terms</h2>
                                        <p className="mb-24">
                                            By accessing, browsing, or using Karnataka Police TV Magazine, you
                                            acknowledge that you have read, understood, and agreed to these Terms &amp;
                                            Conditions, along with our Privacy Policy.
                                        </p>
                                        <h2>2. About Karnataka Police TV Magazine</h2>
                                        <p className="mb-24">
                                            Karnataka Police TV Magazine is an informational platform dedicated to
                                            sharing news, updates, awareness programs, public safety information,
                                            community initiatives, interviews, and educational content related to law
                                            enforcement, public welfare, and social development.
                                        </p>
                                        <h2>3. Use of Website</h2>
                                        <p className="mb-24">Users agree to:</p>
                                        <ul className="mb-24">
                                            <li>Use the website only for lawful purposes.</li>
                                            <li>
                                                Not engage in any activity that may disrupt or interfere with the
                                                website's functionality.
                                            </li>
                                            <li>
                                                Not attempt to gain unauthorized access to any part of the website,
                                                servers, or databases.
                                            </li>
                                            <li>Respect the rights and privacy of other users and contributors.</li>
                                        </ul>
                                        <h2>4. Intellectual Property Rights</h2>
                                        <p className="mb-24">
                                            All content published on Karnataka Police TV Magazine, including text,
                                            images, videos, graphics, logos, articles, designs, and other materials, is
                                            protected by applicable copyright and intellectual property laws.
                                        </p>
                                        <p className="mb-24">Users may:</p>
                                        <ul className="mb-24">
                                            <li>View and share content for personal and non-commercial purposes.</li>
                                            <li>Reference content with proper attribution.</li>
                                        </ul>
                                        <p className="mb-24">Users may not:</p>
                                        <ul className="mb-24">
                                            <li>
                                                Copy, reproduce, distribute, modify, or republish content without prior
                                                written permission.
                                            </li>
                                            <li>Use website content for commercial purposes without authorization.</li>
                                        </ul>
                                        <h2>5. News and Information Disclaimer</h2>
                                        <p className="mb-24">
                                            The content provided on Karnataka Police TV Magazine is intended for
                                            informational and educational purposes only. While we strive to ensure
                                            accuracy and reliability, we do not guarantee the completeness, accuracy, or
                                            timeliness of the information published.
                                        </p>
                                        <p className="mb-24">
                                            Readers are encouraged to verify critical information through official
                                            government or law enforcement sources when necessary.
                                        </p>
                                        <h2>6. User-Generated Content</h2>
                                        <p className="mb-24">
                                            If users submit comments, feedback, articles, photographs, videos, or other
                                            content:
                                        </p>
                                        <ul className="mb-24">
                                            <li>The user retains ownership of their content.</li>
                                            <li>
                                                The user grants Karnataka Police TV Magazine a non-exclusive, royalty-free
                                                license to publish, display, and distribute such content.
                                            </li>
                                            <li>The user is solely responsible for the content they submit.</li>
                                            <li>
                                                Content that is unlawful, defamatory, abusive, misleading, or violates the
                                                rights of others may be removed without notice.
                                            </li>
                                        </ul>
                                        <h2>7. External Links</h2>
                                        <p className="mb-24">
                                            Our website may contain links to third-party websites for informational
                                            purposes. Karnataka Police TV Magazine does not endorse or assume
                                            responsibility for the content, policies, or practices of external websites.
                                        </p>
                                        <h2>8. Privacy</h2>
                                        <p className="mb-24">
                                            Your use of this website is also governed by our Privacy Policy. We are
                                            committed to protecting user privacy and handling personal information
                                            responsibly.
                                        </p>
                                        <h2>9. Limitation of Liability</h2>
                                        <p className="mb-24">
                                            Karnataka Police TV Magazine, its management, contributors, employees, and
                                            affiliates shall not be liable for any direct, indirect, incidental,
                                            consequential, or special damages arising from:
                                        </p>
                                        <ul className="mb-24">
                                            <li>Use or inability to use the website.</li>
                                            <li>Errors or omissions in content.</li>
                                            <li>Website interruptions or technical issues.</li>
                                            <li>Unauthorized access to user information.</li>
                                        </ul>
                                        <h2>10. Modification of Content and Services</h2>
                                        <p className="mb-24">
                                            We reserve the right to modify, update, suspend, or discontinue any part of
                                            the website, services, or content at any time without prior notice.
                                        </p>
                                        <h2>11. Changes to Terms &amp; Conditions</h2>
                                        <p className="mb-24">
                                            Karnataka Police TV Magazine may revise these Terms &amp; Conditions
                                            periodically. Updated versions will be posted on this page, and continued
                                            use of the website constitutes acceptance of any changes.
                                        </p>
                                        <h2>12. Governing Law</h2>
                                        <p className="mb-24">
                                            These Terms &amp; Conditions shall be governed and interpreted in accordance
                                            with the laws of India. Any disputes arising from the use of this website
                                            shall be subject to the jurisdiction of the competent courts in Karnataka.
                                        </p>
                                        <h2>13. Contact Information</h2>
                                        <p className="mb-24">
                                            For any questions, concerns, or inquiries regarding these Terms &amp;
                                            Conditions, please contact:
                                        </p>
                                        <p className="mb-24">
                                            <strong>Karnataka Police TV Magazine</strong>
                                            <br />
                                            Email: info@karnatakapolicetvmagazine.com
                                            <br />
                                            Phone: 080-26623007
                                            <br />
                                            Address: #65, 3rd Floor, SSR Archade, Gandhi Bazaar Main Road, Basavanagudi, Bangalore, Karnataka - 560004
                                        </p>
                                        <p className="mb-24">
                                            By using Karnataka Police TV Magazine, you agree to abide by these Terms
                                            &amp; Conditions.
                                        </p>
                                    </div>


                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="blog-sidebar__wrapper">



                                    <div
                                        className="blog-sidebar__wrap mb-20 wow fadeInUp"
                                        data-wow-duration="0.7s"
                                        data-wow-delay="0.2s"
                                    >
                                        <h3 className="blog-sidebar__title">Advertisement</h3>
                                        <div className="blog-sidebar__gallery blog-sidebar__gallery-2">


                                            {ads.length > 0 && (

                                                <>


                                                    {ads.map((ad) => (

                                                        <div className="" key={ad.id}>

                                                            <img src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`} alt={ad.ads_title} />

                                                        </div>

                                                    ))
                                                    }

                                                </>

                                            )}



                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>














            </main >

            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default Terms;